import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperAddCorrporateDialog: {
    display: "flex",
    flexDirection: "row",
  },
  containerLeftSide: {
    display: "flex",
    flexDirection: "column",
    background: theme.palette.background.gray_200,
    width: "336px",
    padding: "20px 24px",
    gap: "16px",
  },
  containerRightSide: {
    background: theme.palette.background.paper,
    padding: "20px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
  },
  containerContentDialog: {
    padding: `20px 0px 0px 0px !important`,
  },
  containerItemInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  lableInfo: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
  valueInfo: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.text.secondary,
  },
  containerInputFiled: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
  },
  titleInput: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.text.secondary,
    maxWidth: "160px",
    minWidth: "160px",
  },
  containerWebsiteFiled: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  } , uploadedSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "16px",
  },
  containerUpladedFilesCrads: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  CardUploadedFilesInfo: {
    display: "flex",
    flexDirection: "row",
    padding: "16px",
    gap: "12px",
  },
  ContainerFileUploadedInfo: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  containerTitleAndDeleteIcon: {
    position: "relative",
  },
  DeleteIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0px",
    top: "0px",
  },
  TitleFileName: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "330px",
    display: "inline-block",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },
  FileSizeTitle: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: theme.palette.text.tertiary,
  },
}));
